import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ShowImg from './../ShowImg';
import './index.less';

// 画廊，展示多张图片
function Gallery (props) {
	const { srcs, className } = props;
	const prefixCls = 'gallery';
	const wrapCls = classnames(prefixCls, className);

	return (
		<div className={wrapCls}>
			{srcs.map((item, index) => (
				<ShowImg
					key={index}
					imgSrc={item}
				/>
			))}
		</div>
	);
}

Gallery.defaultProps = {
	srcs: [],
	className: '',
};

Gallery.propTypes = {
	srcs: PropTypes.array, // 图片链接数组
	className: PropTypes.string,
};

export default Gallery;
